/** YOLO 사람 검출 — UI·DB와 동일 스케일 (서버 하드코딩 하한 없음) */
export const AI_DETECTION_DEFAULTS = {
  conf: 0.3,
  minConsecutiveHits: 3,
} as const;

/** 시설 폼: 시설 전체 기본값 (검출 성향 5단계=balanced 와 동일) */
export const POOL_AI_DEFAULTS = {
  ai_detection_conf: 0.3,
  ai_detection_min_consecutive_hits: 3,
} as const;

export const AI_DETECTION_HINTS = {
  conf:
    '【의미】YOLO가 박스를 “사람”으로 채택할 최소 신뢰도(0.05~0.99). 이 값보다 낮으면 버림.\n' +
    '【기본·권장 0.30】yolov8n(COCO)+물놀이장에서 미탐을 줄이려면 이 근처부터. (모델이 이 점수 미만 박스를 출력하지 않음.)\n' +
    '【올릴 때】꼬깔·물결 오탐↑이면 0.35~0.45. 원거리·수중 미탐이 느기 가능.\n' +
    '【낮출 때】사람을 자주 놓치면 0.22~0.28. 오탐도 함께 느기 가능.\n' +
    '【주의】실제 추론은 이 UI 값을 그대로 씀.',
  minHits:
    '【의미】같은 추적 ID로 “사람”이 연속 검출된 프레임 수(1~30). 이상일 때만 확정 추적·화면에 넣음.\n' +
    '【기본 1~3】처리 FPS에 따라 짧게 연속으로 잡혀야 확정됨.\n' +
    '【올릴 때】오탐이 많으면 4~5. 【낮출 때】반응을 빠르게 하려면 1~2.',
  cctvOverrideIntro:
    '이 카메라 영상에만 적용됨. 각도·줌·물결·조명이 카메라마다 다르므로 여기서 조정하는 것이 가장 효과적.',
  cctvConfEmpty:
    '비우면 시설에 저장한 기본값(또는 시스템 신뢰도 하한)을 사용. 이 카메라만 다르게 쓰려면 숫자를 입력.',
  cctvMinHitsEmpty:
    '비우면 시설 기본값(또는 시스템 연속 프레임)을 사용. 이 카메라만 다르게 쓰려면 숫자를 입력.',
  poolFallback:
    'CCTV에서 해당 항목을 비워 두었을 때만 이 값이 사용됨. 보통은 CCTV 관리 화면에서 카메라마다 조정하고, 여기는 시설 단위 기본값으로 두면 됨.',
  poolDetectorModel:
    '【고급】backend/models/ 에 있는.pt 중에서 선택. 「공통 모델 사용」이면 전역 monitoring_ai 기본 weights를 씀.\n' +
    '파도풀 등 특수 시설은 이 시설만 별도 학습한 가중치를 지정.',
} as const;
